var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"datepicker",class:_vm.inputClass,attrs:{"type":"text","placeholder":_vm.placeholder,"readonly":""},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.update($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }